export default (vueInstance, objectName, variables: any) => {
  vueInstance.$apollo.queries[objectName].fetchMore({
    variables,
    updateQuery: (previousResult, { fetchMoreResult }) => {
      const newData = fetchMoreResult[objectName].data
      const nextCursor = fetchMoreResult[objectName].nextCursor
      return {
        [objectName]: {
          __typename: previousResult[objectName].__typename,
          data: [...previousResult[objectName].data, ...newData], // Merging the data
          nextCursor,
        },
      }
    },
  })
}